<template>
    <div>
        <div>
            <el-row>
                <el-col :span="24">
                    <div class="d-block d-md-flex justify-content-end align-items-center search-table">
                        <slot name="searchBox"></slot>
                    </div>
                </el-col>
            </el-row>
            <div class="filter-box" v-if="$slots.filterBox">
                <slot name="filterBox"></slot>
            </div>
            <div class="table-sm table-kb">
                <table class="table custom-table table-hover table-common" id="basicExample">
                    <thead>
                        <template v-if="config.headers">
                            <tr>
                                <th v-if="isCheckHeader" class="col-check">
                                    <label class="ckbox mb-0">
                                        <input type="checkbox" v-model="isCheckAllRecord" @change="changeCheckAll" />
                                        <span></span>
                                    </label>
                                </th>
                                <th v-for="(item, k) in config.headers" :key="k" :class="{ 'has-action': item.sort || item.callback, 'sort-active': item.sort === model.sort.field }">
                                    <div class="d-flex th-sort" :class="{ 'justify-content-sm-between': item.sort, 'justify-content-start': !item.sort }">
                                        {{ $t(item.label) }}
                                        <template v-if="item.sort">
                                            <span class="sort-item ml-1" @click="handleAction(item)">
                                                <i class="el-icon-top" :class="{ 'sort-active': item.sort === model.sort.field && model.sort.order === 'asc' }"></i>
                                                <i class="el-icon-bottom" :class="{ 'sort-active': item.sort === model.sort.field && model.sort.order === 'desc' }"></i>
                                            </span>
                                        </template>
                                    </div>
                                </th>
                            </tr>
                        </template>

                        <slot v-else name="head"></slot>
                    </thead>
                    <tbody v-if="isLoading">
                        <tr>
                            <td class="text-center pt-5" :colspan="config.headers ? config.headers.length : 2">
                                <box-loading></box-loading>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <template v-for="(row, index) in dataList">
                            <slot name="row" :row="row" :index="index" :page="model.page" :perPage="model.limit"></slot>
                        </template>
                        <tr v-if="dataList && dataList.length === 0">
                            <td class="py-2 col-empty" :colspan="config.headers ? config.headers.length : 2">
                                <el-empty :description="this.$t(`text.msgNoData`)" :image-size="300"> </el-empty>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-box__footer">
                <div class="text-right">
                    <Pagination v-if="total" :total="total" :page.sync="model.page" :per-page="model.limit * 1" @updatePerPage="updatePerPage"></Pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Component create table
import { PER_PAGE_LIST, TIMING_LOADER } from '@/config/constants';
import Pagination from '../Pagination';
import BoxLoading from '@/components/partials/BoxLoading';
export default {
    name: 'TableBox',
    components: {
        BoxLoading,
        Pagination
    },
    comments: {
        TIMING_LOADER
    },
    props: {
        height: {
            type: String,
            default: '500px'
        },
        dataList: {
            type: Array,
            require: true
        },
        config: {
            type: Object,
            require: true
        },
        reload: {
            require: false
        },
        isCheckHeader: {
            default: false,
            require: false,
            type: Boolean
        },
        isCheckAll: {
            default: false,
            type: Boolean,
            require: false
        }
    },
    watch: {
        isCheckAllRecord(val) {
            this.$emit('update:isCheckAll', val);
        },
        'config.q': function (val) {
            this.model.search = val;
            this.model.page = 1;
        },
        'config.dataFilter': {
            deep: true,
            handler: function (val) {
                this.model.dataFilter = val;
                this.model.page = 1;
            }
        },
        model: {
            deep: true,
            handler: function () {
                clearTimeout(this.retrieveListTimeout);
                this.retrieveListTimeout = setTimeout(() => {
                    this.retrieveList();
                }, 500);
            }
        },
        reload: function () {
            this.retrieveList();
        }
    },
    data() {
        let data = {
            perPageList: PER_PAGE_LIST,
            total: 0,
            isLoading: false,
            retrieveListTimeout: null,
            model: {
                page: 1,
                dataFilter: {},
                limit: PER_PAGE_LIST[0],
                filters: {},
                search: '',
                dataLinkMultiId: '',
                sort: {
                    field: '',
                    order: ''
                }
            }
        };
        data.model.dataFilter = this.config.dataFilter ?? null;
        data.model.search = this.config.q ?? '';
        data.model.sort = this.config.sort ?? { field: '', order: '' };
        data.model.dataLinkMultiId = this.config.dataLinkMultiId ?? '';
        data.isCheckAllRecord = false;
        return data;
    },
    computed: {},
    mounted() {
        this.retrieveList();
        this.isCheckAllRecord = this.isCheckAll;
    },
    methods: {
        changeCheckAll() {
            if (!this.isCheckAllRecord) {
                this.$emit('clearSelectRecord', true);
            }
        },

        handleAction(header) {
            if (header.sort) {
                this.handleSort(header.sort);
            } else if (header.callback && typeof header.callback === 'function') {
                header.callback();
            }
        },
        handleSort(field) {
            let originOrder = this.model.sort.field === field ? this.model.sort.order : '';
            let order;
            switch (originOrder) {
                case 'asc':
                    order = 'desc';
                    break;
                case 'desc':
                    order = '';
                    field = '';
                    break;
                default:
                    order = 'asc';
            }
            this.model.sort.field = field;
            this.model.page = 1;
            this.model.sort.order = order || 'desc';
            this.model.sort = Object.assign({}, this.model.sort);
            this.model = Object.assign({}, this.model);
        },
        retrieveList: function () {
            if (this.isLoading || !this.config.action) return;
            this.isLoading = true;

            let payload = {
                successCallback: (response) => {
                    let { data } = response.data;
                    this.$emit('update:data-list', data['data_list']);
                    this.total = data.metadata.total;
                    this.model.page = Number(data.metadata.current_page);
                    this.model.limit = Number(data.metadata.limit);
                    if (!data['data_list'].length && this.model.page !== 1) {
                        this.model.page = this.model.page - 1 || 1;
                    }
                    this.$emit('page', this.model.page);
                    this.isLoading = false;
                },
                errorCallback: () => {
                    this.isLoading = false;
                    this.$emit('update:data-list', []);
                    this.total = 0;
                },
                query: this.getQueryString()
            };

            this.$store.dispatch(this.config.action, payload);
        },
        getQueryString() {
            let { model } = this;
            model.search = this.config.q;
            let query = [`page=${model.page}`, `limit=${model.limit}`];
            if (model.sort.field) {
                let sortField = model.sort.field;
                query.push(`sort[${sortField}]=${model.sort.order}`);
            }
            if (model.dataLinkMultiId) {
                query.push(`data_link_multi_id=${model.dataLinkMultiId}`);
            }
            if (model.search) {
                query.push(`q=${model.search}`);
            }
            if (model.dataFilter) {
                for (const [key, value] of Object.entries(model.dataFilter)) {
                    if (key && value !== null && value !== '') {
                        query.push(`filter[${key}]=${value}`);
                    }
                }
            }
            return query.join('&');
        },
        updatePerPage(value) {
            this.model.limit = value;
            this.model.page = 1;
        },
        updateLimit(value) {
            this.model.page = 1;
        }
    }
};
</script>
